declare global {
  interface Window {
    onYouTubeIframeAPIReady: () => void
    YT: {
      Player: (id: string, option: unknown) => void
    }
  }
}

import React from 'react'

export type VideoStateChangeEvent = {
  data: number
}

export type Props = {
  autoplay?: boolean
  className?: string
  height?: string
  onStateChange?: (arg0: VideoStateChangeEvent) => void
  title?: string
  videoId: string
  width?: string
}

const checkExistingScripts = (): Array<string> =>
  [...document.querySelectorAll('script')].map((script) => script.src)

class YouTube extends React.PureComponent<Props> {
  static defaultProps = {
    autoplay: false,
    className: '',
    height: '270',
    title: 'Youtube video player',
    width: '480',
  }

  baseUrl: string

  id: string

  player: unknown

  constructor(props: Props) {
    super(props)
    this.baseUrl = 'https://www.youtube.com/embed'
    this.id = `ytPlayer-${props.videoId}`
  }

  componentDidMount() {
    const { onStateChange } = this.props
    const api = 'https://www.youtube.com/iframe_api'
    const existingScripts = checkExistingScripts()
    const loaded = existingScripts.includes(api)

    if (!loaded) {
      const script = document.createElement('script')
      script.src = api
      if (document.body) {
        document.body.appendChild(script)
      }
    }

    window.onYouTubeIframeAPIReady = () => {
      const events: Record<string, (arg: VideoStateChangeEvent) => void> = {}

      if (onStateChange) {
        events.onStateChange = onStateChange
      }
      this.player = new window.YT.Player(this.id, {
        events,
      })
    }
  }

  render() {
    const {
      autoplay: isAuto,
      className,
      height,
      title,
      videoId,
      width,
    } = this.props
    const autoplay = isAuto ? 1 : 0

    return (
      <div className={className}>
        <iframe
          allow='autoplay'
          allowFullScreen
          frameBorder='0'
          height={height}
          id={this.id}
          src={`${this.baseUrl}/${videoId}?autoplay=${autoplay}&modestbranding=1&rel=0&enablejsapi=1&origin=https://crossfit.com`}
          title={title}
          width={width}
        />
      </div>
    )
  }
}

export default YouTube
